<div ng-controller="bulkUpdateController as ctrl" class="bulk-update modal-view">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>